export enum StatusEnum {
    "active" = 1,
    "inactive" = 2,
    "suspended" = 3,
    "deleted" = 4,
    "pending" = 5,
    "approved" = 6,
    "rejected" = 7,
    "completed" = 8,
    "cancelled" = 9,
    "expired" = 10,
  }
  